/**
 * Indicates the readiness state of the media.
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
 */
export var MediaReadyState;
(function (MediaReadyState) {
    /**
     * No information is available about the media resource.
     */
    MediaReadyState[MediaReadyState["HaveNothing"] = 0] = "HaveNothing";
    /**
     * Enough of the media resource has been retrieved that the metadata attributes are initialized.
     * Seeking will no longer raise an exception.
     */
    MediaReadyState[MediaReadyState["HaveMetadata"] = 1] = "HaveMetadata";
    /**
     * Data is available for the current playback position, but not enough to actually play more
     * than one frame.
     */
    MediaReadyState[MediaReadyState["HaveCurrentData"] = 2] = "HaveCurrentData";
    /**
     * Data for the current playback position as well as for at least a little bit of time into
     * the future is available (in other words, at least two frames of video, for example).
     */
    MediaReadyState[MediaReadyState["HaveFutureData"] = 3] = "HaveFutureData";
    /**
     * 	Enough data is available—and the download rate is high enough—that the media can be played
     * through to the end without interruption.
     */
    MediaReadyState[MediaReadyState["HaveEnoughData"] = 4] = "HaveEnoughData";
})(MediaReadyState || (MediaReadyState = {}));
